/*
 * @Author: princemwang
 * @Date: 2022-06-22 10:38:23
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-02-01 10:55:03
 */
import { request } from '@/request';
import { Status, ReportInfo, VerifyWebcastId, RequestType } from '@/request/reqType';

/**
 * @description 登记访客信息
 * @param data
 * @returns
 */
export const setGuestInfo = <T extends keyof RequestType>(data: RequestType[T]) => {
  return request<'guest'>({
    url: '/webcast/v1/guest/register',
    method: 'post',
    data,
  });
};
/**
 * @description 获取直播状态
 */
export const getLiveStatus = (data: Status) => {
  return request<'status'>({
    url: '/webcast/v1/status/query',
    method: 'post',
    data,
  });
};
/**
 * @description 获取ppt图片列表
 * @param params
 * @returns
 */
export const getDocs = (data: Status) => {
  return request<'doc'>({
    url: '/webcast/v1/doc/query',
    method: 'post',
    data,
  });
};
/**
 * @description 统计客户端信息
 * @param data
 * @returns
 */
export const reportInfo = (data: ReportInfo) => {
  return request<'report'>({
    url: '/webcast/v1/stat/update',
    method: 'post',
    data,
  });
};
/**
 * @description 验证webcastId
 * @param data
 * @returns
 */
export const verifyWebcast = (data: VerifyWebcastId) => {
  return request<'verify'>({
    url: '/webcast/v1/webcast/verify',
    method: 'post',
    data,
  });
};
